import { ProjectProps } from "@/interfaces/project_types";

/**
 * This is a component that displays the status of an invoice.
 * It is used in the ProjectList component to display the status of an invoice.
 * @param row - The row of the project.
 * @returns The status of the invoice.
 */
export function InvoiceStatus({row}: {row: ProjectProps}) {
    if (row.latest_invoice === null) {
        return (
            <div>
                <span className="italic text-gray-500 dark:text-gray-400">(No Invoice)</span>
            </div>
        )
    }

    else if (row.latest_invoice?.payment_status === "Sent") {
        return (
            <div>
                {`${row.latest_invoice?.payment_amount}% Sent`}
            </div>
        )
    }

    else {
        return (
            <div>
               Pending
            </div>
        )
    }

}